import React from 'react';

import RightClickMenu from 'components/RightClickMenu/RightClickMenu';

import { StepIndicator, Step } from 'components/StepIndicator';

import { Divisor } from 'components';
import { StripeCardForm } from 'apps/payment/method/newCardForm';

import { MainWrapper, MaiColumnnWrapper } from './styles';

const optionsMock = [
  {
    icon: 'cube',
    label: 'Make!',
    onClick: () => {},
  },
  {
    icon: 'download',
    label: 'Download as...',
    onClick: () => {},
    options: [
      {
        loading: true,
        loadLabel: 'Processing...',
        icon: 'download',
        iconLast: true,
        label: '.step File',
        extraLabel: '3.3 MB',
        onClick: () => {},
      },
      {
        loading: false,
        loadLabel: 'Processing...',
        icon: 'download',
        iconLast: true,
        label: '.stil File',
        extraLabel: '5.7 MB',
        onClick: () => {},
      },
    ],
  },
];

const TestPage = () => {
  return (
    <MainWrapper>
      <div className='flex flex-col items-center w-full mt-1 text-center'>
        <StepIndicator activeStepKey='step1'>
          <Step key='step1'>Add Collaborators</Step>
          <Step key='step2'>Payment Details</Step>
          <Step key='step3'>Review</Step>
        </StepIndicator>
        <Divisor mt={2} />
      </div>
    </MainWrapper>
  );
};

export default TestPage;
